export default {
  getAllSkills(state) {
    return state.allSkills;
  },
  getAllAdmins(state) {
    return state.allAdmins;
  },
  getAdminList(state) {
    return state.admins;
  },

  getCompanies(state) {
    return state.companies;
  },

  getEducations(state) {
    return state.educations;
  },
  getCompany(state) {
    return state.company;
  },
  getJobs(state) {
    return state.allJobs;
  },
  getAllInsights(state) {
    return state.allInsights;
  },
  getCandidateJobApplied(state) {
    return state.allCandidateJobApplied;
  },
  getPendingUsers(state) {
    return state.pendingUsers;
  },
};
